var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29210",
    "data-name": "Rectangle 29210",
    width: 50,
    height: 50,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_638",
    "data-name": "Mask Group 638",
    clipPath: "url(#folder)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_76_",
    "data-name": "svgexport-6 (76)",
    transform: "translate(0 5.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11504",
    "data-name": "Path 11504",
    d: "M3.058,12.839,7.6,6.511a2.514,2.514,0,0,1,2.033-.874H27.818c1.255,0,2.273.708,2.273,1.582v6.328c0,.874-1.018,1.582-2.273,1.582H5.091a2.612,2.612,0,0,1-1.934-.75,1.178,1.178,0,0,1-.1-1.539Z",
    transform: "translate(19.909 -5.007)",
    fill: "#6342ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11505",
    "data-name": "Path 11505",
    d: "M5.091,16.909H52.818V51a2.273,2.273,0,0,1-2.273,2.273H5.091A2.273,2.273,0,0,1,2.818,51V19.182A2.273,2.273,0,0,1,5.091,16.909Z",
    transform: "translate(-2.818 -11.333)",
    fill: "#7e59d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.81b45a111c686ec57415c0dc116b2349.svg";
export { ForwardRef as ReactComponent };